export default __webpack_public_path__ + "static/media/sign_up_head2.e4c86011.png";